import React from 'react';
import { Cross, Star, Bird, Crown, Heart, Shield, Youtube, Mail } from 'lucide-react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="py-12 bg-slate-900 border-t border-amber-400/20 relative">
      {/* Decorative cross pattern */}
      <div className="absolute inset-0 opacity-5">
        <div className="grid grid-cols-12 gap-8 p-8">
          {[...Array(36)].map((_, i) => (
            <Cross key={i} className="w-3 h-3 text-amber-400" />
          ))}
        </div>
      </div>
      
      <div className="container mx-auto px-4 sm:px-6 relative">
        <div className="text-center">
          <div className="flex items-center justify-center space-x-2 sm:space-x-3 mb-4 sm:mb-6">
            <Shield className="w-6 h-6 sm:w-8 sm:h-8 text-amber-400" />
            <Cross className="w-8 h-8 sm:w-10 sm:h-10 text-amber-400" />
            <Bird className="w-6 h-6 sm:w-8 sm:h-8 text-amber-400" />
            <div className="text-center">
              <Link to="/">
                <h3 className="text-lg sm:text-xl font-bold text-amber-400 hover:text-amber-300 transition-colors">
                  Cuvânt și Rugăciune
                </h3>
                <p className="text-xs sm:text-sm text-slate-400">cu Mircea Stanciu</p>
              </Link>
            </div>
            <Star className="w-6 h-6 sm:w-8 sm:h-8 text-amber-400" />
            <Crown className="w-8 h-8 sm:w-10 sm:h-10 text-amber-400" />
            <Heart className="w-6 h-6 sm:w-8 sm:h-8 text-amber-400" />
          </div>
          
          <p className="text-sm sm:text-base text-slate-400 mb-4 sm:mb-6 max-w-2xl mx-auto px-4">
            "Căci Cuvântul lui Dumnezeu este viu și lucrător, mai ascuțit decât orice sabie cu două tăișuri" - Evrei 4:12
          </p>
          
          {/* Quick Links */}
          <div className="flex flex-wrap justify-center gap-4 sm:gap-6 mb-6 text-sm">
            <Link to="/despre" className="text-slate-400 hover:text-amber-400 transition-colors">Despre</Link>
            <Link to="/episoade" className="text-slate-400 hover:text-amber-400 transition-colors">Episoade</Link>
            <Link to="/studii" className="text-slate-400 hover:text-amber-400 transition-colors">Studii Biblice</Link>
            <Link to="/rugaciuni" className="text-slate-400 hover:text-amber-400 transition-colors">Rugăciuni</Link>
            <Link to="/contact" className="text-slate-400 hover:text-amber-400 transition-colors">Contact</Link>
          </div>
          
          <div className="flex justify-center space-x-6 mb-4 sm:mb-6">
            <a href="https://www.youtube.com/@mircea_stanciu" className="text-slate-400 hover:text-amber-400 transition-colors">
              <Youtube className="w-5 h-5 sm:w-6 sm:h-6" />
            </a>
            <a href="mailto:virgilstaciu31@gmail.com" className="text-slate-400 hover:text-amber-400 transition-colors">
              <Mail className="w-5 h-5 sm:w-6 sm:h-6" />
            </a>
            <a href="https://chat.whatsapp.com/DqlrnJxLjzwHKtsSAgGbaJ" className="text-slate-400 hover:text-amber-400 transition-colors">
              <Heart className="w-5 h-5 sm:w-6 sm:h-6" />
            </a>
          </div>
          
          <div className="flex justify-center items-center space-x-2 mb-4">
            <Star className="w-4 h-4 text-amber-400" />
            <p className="text-xs sm:text-sm text-slate-500">
              © 2025 Cuvânt și Rugăciune. Toate drepturile rezervate.
            </p>
            <Star className="w-4 h-4 text-amber-400" />
          </div>
          
          <div className="flex justify-center items-center space-x-4 text-xs text-slate-600 mb-4">
            <Bird className="w-3 h-3" />
            <span>Să ne rugăm împreună</span>
            <Cross className="w-3 h-3" />
            <span>Prin credință</span>
            <Crown className="w-3 h-3" />
          </div>
          
          {/* Disclaimer modalità test */}
          <div className="bg-slate-800/50 border border-amber-400/20 rounded-xl p-4 max-w-2xl mx-auto">
            <div className="flex items-center justify-center space-x-2 mb-2">
              <Star className="w-4 h-4 text-amber-400" />
              <h4 className="text-sm font-semibold text-amber-400">Notă Importantă</h4>
              <Star className="w-4 h-4 text-amber-400" />
            </div>
            <p className="text-xs text-slate-400 text-center leading-relaxed">
              Sistemul nostru de email este momentan în modul de testare. 
              Cererile tale de rugăciune și înregistrările la newsletter sunt primite și salvate, 
              dar confirmările prin email vor fi disponibile în versiunea finală. 
              Mulțumim pentru înțelegere! 🙏
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;